import { render, staticRenderFns } from "./RemoteSelect.vue?vue&type=template&id=2cf46961&"
import script from "./RemoteSelect.vue?vue&type=script&lang=js&"
export * from "./RemoteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports